module.exports = __webpack_public_path__ + "static/4-3ea1dae8288522b6606018af85707577.png";